import { createConnectorConfigDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createConnectorConfigCallable = getCallable(
  createConnectorConfigDefinition,
);
